import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { connect } from 'react-redux';

class DisplayError extends Component {

  state = { showModal: true };

  closeModal = () => {
    this.setState({ showModal: false });
  }

  render() {
    const { displayError } = this.props;

    return (
      <Dialog open={Boolean(displayError) && this.state.showModal} onClose={this.closeModal} >
        <DialogContent>
          {displayError}
        </DialogContent>

      </Dialog>
    );
  }
}


function mapStateToProps(state) {
  return { displayError: state.xpa.error };
}

export default connect(mapStateToProps)(DisplayError);



// WEBPACK FOOTER //
// ./src/components/Common/DisplayError.js